import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_MENU_TITLE_MUTATION } from '../graphql/mutations'
import { UPDATE_MENU_TITLE } from '../redux/action-types'

const useUpdateMenuTitleMutation = menuTitleId => {
  const dispatch = useDispatch()

  const { updateMenuTitleError, updateMenuTitleLoading, updateMenuTitleId } =
    useSelector(store => store.menuCurationTasks.menuCurationTask)

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate({
        mutation: UPDATE_MENU_TITLE_MUTATION,
        variables: { id, data },
        dispatch,
        action: UPDATE_MENU_TITLE,
      }),
    [dispatch],
  )

  return [
    mutate,
    ...(updateMenuTitleId === menuTitleId
      ? [{ error: updateMenuTitleError, isLoading: updateMenuTitleLoading }]
      : [{ error: null, isLoading: false }]),
  ]
}

export default useUpdateMenuTitleMutation
